export default __webpack_public_path__ + "static/media/8.ff5c2450.jpg";